import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ButtonToolbar, ButtonGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BAGGAGE_PATH, NEW_BAGGAGE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import BaggageSearchResult from './BaggageSearchResult';
import Content from '../../../layout/Content';

export const Baggages = ({ breadcrumbs }) => {
  const [searchFormValues] = useState({});

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <ButtonGroup>
        <Link className="btn btn-primary" to={NEW_BAGGAGE_PATH}>
          <i className="fa fa-plus" /> Crear
        </Link>
      </ButtonGroup>
    </ButtonToolbar>
  );

  const title = 'Búsqueda de Equipajes';

  const subtitle = (
    <>
      Busca por <strong>Boleto de Viaje</strong> o{' '}
      <strong>Boleta de Exceso</strong>.
    </>
  );

  const content = (
    <>
      <BaggageSearchResult searchFormValues={searchFormValues} />
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title={title}
      subtitle={subtitle}
      toolbar={toolbar}
      content={content}
    />
  );
};

const mapStateToProps = ({ BaggageUnit }) => ({
  breadcrumbs: [
    ...BaggageUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Equipajes y Excesos',
      href: BAGGAGE_PATH,
    },
  ],
});

const mapDispatchToProps = {};

Baggages.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Baggages);
